<template>
  <div>
    <a-descriptions title="配置信息" :column="2">
      <a-descriptions-item label="Profile供应商">
        {{ data.profile_supplier_name }}
      </a-descriptions-item>
    </a-descriptions>
  </div>
</template>

<script>
export default {
  name: 'AgentPurchaseItemProfileConfigureInfo',
  props: {
    data: {
      type: Object,
      required: true
    }
  }
}
</script>
